import {Injectable, isDevMode} from '@angular/core';
import Cookies from 'js-cookie';
import {HttpClient} from './http.service';
import {Logger} from '../logging/default-log.service';
import {BaseService} from './base.service';
import {ConfigurationHelper} from '../helper/configuration.helper';
import {ApplicationService} from './application.service';

@Injectable({
	providedIn: 'root'
})
export class CookieService extends BaseService {
	readonly WEBSITE_COOKIE_URL_ENDPOINT: string = '/app/cookiepolicy';

	readonly WEBSHOP_COOKIE_URL_ENDPOINT: string = '/public/cookiepolicy';

	constructor(
		private applicationService: ApplicationService,
		private http: HttpClient,
		logger: Logger
	) {
		super(logger);
	}

	public setCookieByName(name: string, value: any): void {
		const windowObj = <any>window;

		Cookies.set(name, value, {
			expires: 365,
			domain: `${windowObj.cookieDomain}`,
			secure: !isDevMode()
		});
	}

	public getCookieByName(name: string): any {
		return Cookies.get(name);
	}

	public getCookiePolicyUrl(): Promise<string | void> {
		let cookieUrl: URL = new URL(ConfigurationHelper.getWebshopUrl(`${this.WEBSHOP_COOKIE_URL_ENDPOINT}`));

		if (this.applicationService.isBrowsingWebsite(window.location.href)) {
			cookieUrl = new URL(`${ConfigurationHelper.getWebsiteUrl(this.WEBSITE_COOKIE_URL_ENDPOINT)}`);
			cookieUrl.searchParams.append(
				'isoLang',
				this.applicationService.getWebsiteLanguage()
			);
		}

		return this.http
			.getText(cookieUrl.href, false)
			.toPromise()
			.catch(() => this.logger.warn('Could not find cookie policy url'));
	}
}
